import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import ProfilePicture from 'components/profile/profile-picture'

import { Draggable, Droppable } from 'react-beautiful-dnd'

import copy from 'fast-copy'

import Checkbox from 'components/input/checkbox'
import DragHandle from 'components/drag-handle/drag-handle'

import FlipMove from 'react-flip-move'

class TaskMenu extends Component {
	debounced = true
	items = []
	inputRefs = []
	state = {
		isEdited: false,
		searchTerm: '',
		hideItems: false
	}

	componentDidMount() {
		if (this.searchRef && !this.props.isSingle) {
			this.searchRef.focus()
		}
	}

	clickItem = item => {
		const {
			isDisabled,
			selectCallback,
			dismissCallback,
			type
		} = this.props

		if (isDisabled) {
			return
		}

		if (this.debounced && !this.state.isEdited) {
			this.setDebounce()
			selectCallback(item)

			if (type !== 'people') {
				dismissCallback()
			}
		}
	}

	setDebounce = _ => {
		this.debounced = false

		setTimeout(_ => {
			this.debounced = true
		}, 5);
	}

	toggleEditing = e => {
		let statuses = copy(this.props.menuItems)

		statuses.forEach(status => {
			if (status.id <= 3 && !status.custom_name) {
				status.custom_name = status.name;
			}
		})

		this.setState({
			isEdited: !this.state.isEdited,
			statuses
		}, _ => {
			if (this.state.isEdited) {
				this.inputRefs[0].focus()
			}
		})
	}

	handleSearchChange = e => {
		this.setState({
			searchTerm: e.target.value
		})
	}

	changeMenuItemName = (item, e) => {
		let tempStatuses = copy(this.state.statuses)

		let statusIndex = this.state.statuses.findIndex(status => {
			return status.id === item.id;
		})

		tempStatuses[statusIndex].custom_name = e.target.value;

		this.setState({
			statuses: tempStatuses
		})
	}

	saveTaskMenu = _ => {
		const {
			column,
			saveTaskStatuses,
			projectId,
		} = this.props

		saveTaskStatuses(projectId, this.state.statuses, 'name', column)
		this.toggleEditing()
	}

	handleKeyPress = e => {
		if (e.key === 'Enter') {
			const {
				isEdited
			} = this.state

			if (isEdited) {
				this.saveTaskMenu()
			}
		}
	}

	render() {
		const {
			selectedMenuItems,
			isSelectedCheck,
			isDisabled,
			type,
			isSingle,
			taskId = -1,
			column
		} = this.props

		const {
			isEdited,
			searchTerm,
			statuses,
			hideItems
		} = this.state

		let menuItems = (this.props.menuItems && !hideItems) ? [...this.props.menuItems] : []

		if (type == 'status') {
			if (isEdited) {
				menuItems = statuses

				menuItems.forEach((item, index) => {
					item.order = this.props.menuItems.find(defaultItem => {
						return defaultItem.id == item.id
					}).order
				})
			}

			menuItems.sort((a, b) => {
				return a.order - b.order
			})
		}

		const droppableId = isSingle ? `task-${type}-menu` : `task-${taskId}-${type}-menu`

		return (
			<div
				onClick={e => {
					e.stopPropagation()
				}}
				className={isEdited ? 'editing' : null}
			>
				{
					this.props.hasSearch ?
						<div className="task-menu-search">
							<input
								ref={ref => this.searchRef = ref}
								type="text"
								value={searchTerm}
								onChange={this.handleSearchChange}
							/>
						</div>
						: null
				}
				<Droppable
					droppableId={droppableId}
					type="STATUS"
				>
					{provided => (
						<ul
							ref={provided.innerRef}
							className={'task-menu-container'}
						>
							{menuItems.map((item, i) => {
								let isSelected = false
								let itemName = ''

								if (!item) {
									return null
								}

								if (isSelectedCheck(item, selectedMenuItems)) {
									isSelected = true
								}

								let className = ''

								if (type == 'status') {
									className += 'status'

									if (!item.custom_name && item.id > 3 && !isEdited) {
										className += ' hidden'
									}

									if (item.custom_name) {
										itemName = item.custom_name
									} else if (item.name && !isEdited) {
										itemName = item.name
									}
								} else {
									const usersWithThisFirstName = menuItems.filter(user => {
										return user.first_name == item.first_name
									})

									itemName = item.first_name

									if (usersWithThisFirstName.length > 1) {
										const thisLastInitial = item.last_name.charAt(0)

										const usersWithThisFirstNameAndSameLastInitial = usersWithThisFirstName.filter(user => {
											return user.last_name.charAt(0) === thisLastInitial

										})

										itemName += ' ' + item.last_name.charAt(0)

										if(usersWithThisFirstNameAndSameLastInitial.length > 1){
											itemName += item.last_name.charAt(1)
											itemName += item.last_name.charAt(2)
										}
									}
								}

								if (typeof itemName == 'undefined' || typeof searchTerm == 'undefined') {
									return null
								}

								if (!itemName.toLowerCase().includes(searchTerm.toLowerCase())) {
									return null
								}

								if (isDisabled && !isSelected) {
									return null
								}

								// You can't drag them on single anyway.
								const draggableId = isSingle ? item.id : `task-${taskId} column-${column.id} status-${item.id}`

								return (
									<Draggable
										disableInteractiveElementBlocking={false}
										isDragDisabled={type !== 'status' || !isEdited}
										index={i}
										key={draggableId}
										draggableId={draggableId}
										type="STATUS"
									>
										{ _provided => {
											return (
												<div ref={_provided.innerRef}>
													<li
														className={className}
														{..._provided.draggableProps}
														{..._provided.dragHandleProps}
													>
														<label
															className={isSelected ? 'selected' : null}
															onClick={_ => { this.clickItem(item) }}
														>
															{type == 'status' ?
																<span className={'status-colour colour-id-' + item.colour_id}></span>
																: null}
															{
																(type == 'people' && isSingle) ?
																	<span>
																		<Checkbox
																			isChecked={isSelected}
																			onChange={_ => { this.clickItem(item) }}
																		/>
																		<ProfilePicture
																			isTiny={true}
																			user={item}
																		/>
																		<div className="user-meta">
																			<strong>{item.first_name + ' ' + item.last_name}</strong>
																			<span>
																				{(item.role && item.role != 'null') ?
																					item.role
																					:
																					'Guest'
																				}
																			</span>
																		</div>
																	</span>
																	:
																	<span>
																		{!isSingle ?
																			<DragHandle />
																			: null
																		}
																		{type == 'people' ?
																			<Icon name={isSelected ? 'check-square' : 'square'} />
																			: null}
																		{type == 'people' ?
																			itemName
																			:
																			<input
																				className="status-input"
																				ref={ref => { this.inputRefs[i] = ref }}
																				disabled={!this.state.isEdited}
																				onChange={e => { this.changeMenuItemName(item, e) }}
																				type="text"
																				placeholder={item.id > 3 ? '(Blank status)' : item.name}
																				value={itemName}
																				onKeyPress={this.handleKeyPress}
																			/>
																		}
																	</span>
															}
														</label>
													</li>
													{ _provided.placeholder}
												</div>
											)
										}}
									</Draggable>
								)
							})}
							{provided.placeholder}
						</ul>
					)}
				</Droppable>
				{
					type == 'status' ?
						<div onClick={e => { e.stopPropagation() }} className="edit-menu">
							<button onClick={isEdited ? this.saveTaskMenu : this.toggleEditing}>
								<span>
									<span>
										<Icon name="fe-edit-2" />
										Customise
									</span>
									<span>
										<Icon name="check" />
										Save
									</span>
								</span>
							</button>
							<button onClick={this.toggleEditing}>
								<span>
									<span>
										<Icon name="ban" />
										Cancel
									</span>
								</span>
							</button>
						</div>
						: null
				}
			</div>
		);
	}

}

export default TaskMenu